import { makeStyles } from "@material-ui/core"

import { isSmallScreen } from "@/utils/checkDevice"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

export const CHAT_LEFT_SIDE_WIDTH = "418px"

const useStyles = makeStyles(theme => ({
	chatDrawer: {
		width: "100%",
		height: "100%",
		display: "flex",
		flex: 1
	},
	chatDrawerPaper: {
		position: isSmallScreen ? "absolute" : "relative",
		width: "100%",
		flexWrap: "wrap"
	},
	chatRightSideContainer: {
		flex: 1,
		background: `linear-gradient(310deg, ${colors.purple[100]}, ${colors.beige[100]})`,
		maxHeight: "100%",
		minWidth: 0,
		overflow: "hidden",
		transition: theme.transitions.create("all", {
			easing: theme.transitions.easing.easeOut,
			duration: theme.transitions.duration.enteringScreen
		})
	},
	fixedHeightContainer: {
		height: "100%",
		flex: 1,
		position: "relative"
	},
	chatHeader: {
		...ColorUtil.getBackgroundAndContrastColor(colors.gray[100]),
		padding: theme.spacing(1, 2),
		flexWrap: "wrap"
	},
	logo: {
		width: 40,
		display: "flex",
		alignSelf: "center",
		color: colors.getPrimaryColor(),
		margin: "10px"
	},
	closeIcon: {
		color: colors.gray[900]
	},
	alertContainer: {
		padding: theme.spacing(1)
	}
}))

export default useStyles
